import taboolaFieldsDefined from '../utils/TaboolaDefinition.json';
import _ from 'lodash';

export const excelSheets = [
  {
    original_name: 'Taboola_CampaignReport',
    name: '廣告活動報告',
    selected: true,
  },
  {
    original_name: 'Taboola_DailyReport',
    name: '每日成效報告',
    selected: true,
  },
  {
    original_name: 'Taboola_AdReport',
    name: '廣告素材成效報告',
    selected: true,
  },
  {
    original_name: 'Taboola_AdPerformanceReport',
    name: '廣告文案',
    selected: true,
  },
  {
    original_name: 'Taboola_ConversionReport',
    name: '轉換報告',
    selected: false,
  },
  {
    original_name: 'Taboola_PlatformReport',
    name: '裝置報告',
    selected: false,
  },
  {
    original_name: 'Taboola_RegionReport',
    name: '地區報告',
    selected: false,
  },
  {
    original_name: 'Taboola_AgeReport',
    name: '年齡報告',
    selected: false,
  },
  {
    original_name: 'Taboola_GenderReport',
    name: '性別報告',
    selected: false,
  },
  {
    original_name: 'Taboola_AudienceReport',
    name: '受眾報告_Audience',
    selected: false,
  },
  {
    original_name: 'Taboola_Contextual',
    name: '受眾報告_Contextual',
    selected: false,
  },
  {
    original_name: 'Taboola_AdReport_Campaign',
    name: '素材成效報告(廣告活動)',
    selected: false,
  },
  {
    original_name: 'Taboola_AdPerformanceReport_Campaign',
    name: '廣告文案(廣告活動)',
    selected: false,
  },
]

// taboolaFieldsDefined
//排序欄位
const columnSort = taboolaFieldsDefined.sort((a, b) => {
  return a.categoryIndex - b.categoryIndex;
});

//自定義指標欄位
const initializeCustomFields = [
  {
    category: 'custom',
    name: '自定義指標',
    child: []
  }
]

export const optionalFields = Array.from(new Set(columnSort
  .filter((el) => el.categoryName !== "固定欄位")
  .map((s) => s.categoryName))).map(
    (lab, index) => {
      return {
        category: `${lab}_${index}`,
        name: lab,
        child: columnSort
          .filter((s) => s.categoryName === lab)
          .map((edition) => {
            return {
              name: edition.name,
              name_eng: edition.name_eng,
              expression: edition.googleapi,
              format: edition.format,
              type: edition.type,
              indexNumber: edition.indexNumber,
              sheet: edition.sheet
            };
          })
      };
    }
  );

export const preselectedFields = columnSort
  .filter((s) => s.sheet && s.sheet?.length > 0 && s.categoryName !== "固定欄位")
  .map((edition) => {
    return {
      name: edition.name,
      name_eng: edition.name_eng,
      expression: edition.googleapi,
      format: edition.format,
      type: edition.type,
      indexNumber: edition.indexNumber,
      sheet: edition.sheet
    }
  })
  .sort((a, b) => a.indexNumber - b.indexNumber);